export const DELAY_BETWEEN_MESSAGES = 600;

export enum ACTIONS {
  // modal
  MODAL_OPEN = 'MODAL_OPEN',
  MODAL_CLOSE = 'MODAL_CLOSE',
  // meta
  META_UPDATE_PAGE_URL = 'META_UPDATE_PAGE_URL',
  META_UPDATE_INTENT_ID = 'META_UPDATE_INTENT_ID',
  META_UPDATE_ORIG_PARAMS = 'META_UPDATE_ORIG_PARAMS',
  META_UPDATE_DEALER_OFFER_PARAMS = 'META_UPDATE_DEALER_OFFER_PARAMS',
  META_UPDATE_ARTICLE_URI = 'META_UPDATE_ARTICLE_URI',
}

export enum ROLE {
  BOT,
  USER,
}

export enum UI {
  SELECTOR_CLICKED = 'CHATBOT_UI:SELECTOR_CLICKED',
  CATEGORY_CLICKED = 'CHATBOT_UI:CATEGORY_CLICKED',
  BUTTON_CLICKED = 'CHATBOT_UI:BUTTON_CLICKED',
  CHANGE = 'CHATBOT_UI:CHANGE',
  SEND_MESSAGE = 'CHATBOT_UI:SEND_MESSAGE',
  MODAL_SITE_CLOSE = 'CHATBOT_UI:MODAL_SITE_CLOSE',
  CLOSE_LIVE_CHAT = 'CHATBOT_UI:CLOSE_LIVE_CHAT',
  CANT_LOGIN_CLICKED = 'CHATBOT_UI:CANT_LOGIN_CLICKED',
  NAVIGATED = 'CHATBOT_UI:NAVIGATED',
  DIRECT_SUPPORT_REQUESTED = 'CHATBOT_UI:DIRECT_SUPPORT_REQUESTED',
}

export enum MODE {
  CHATBOT = 'CHATBOT',
  LIVECHAT = 'LIVECHAT',
}

// *** NOTE *** We have this color also in packages/wix-chatbot-client/src/client/styles/variables.scss as $wixStudioDarkColor
export const BACKGROUND_DARK_COLOR = '#131720';

export const WIXEL_CATEGORY = '17d6a822-ed7d-42ed-848e-9f8286495f26';

export const BACKGROUND_LIGHT_COLOR = '#FFFFFF';

export const BACKGROUND_EDITOR3_COLOR = '#F4F4F4';

export const MAX_ARTICLES_SEARCH_OFFSET = 200;

export const ANSWER_GENERATION_TIMEOUT = 25000;
